import type { JsonSchemaDefinition } from "../runtime";

export interface FormTimeSettings {
	TimeMode?: {
		Code?: string;
	};
	TimeZone?: {
		Code?: string;
	};
}

export interface TimeZoneAppState {
	forms: {
		selected?: FormTimeSettings;
	};
}

export function formTimeZone(
	schema: JsonSchemaDefinition,
	form?: FormTimeSettings,
	entityTimeZone?: string
): string | undefined {
	const mode = schema.metadata?.timeZoneMode ?? form?.TimeMode?.Code;

	if(mode === "BYFORM") {
		return form?.TimeZone?.Code;
	}

	if(mode === "BYENTITY") {
		return entityTimeZone;
	}

	return mode === "BYUSER" || mode === "local" ? undefined : form?.TimeZone?.Code;
}
